import React, { useEffect, useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import ContainerPadding from '../containerPadding/containerPadding'
import DialogWithCloseIcon from '../DialogWithCloseIcon/DialogWithCloseIcon'
import useIsMobileScreen from '../../hooks/useIsMobileScreen'
import useHistoryPush from '../../hooks/useHistoryPush'
import useQueryParams from '../../hooks/useQueryParams'
import { isMobileRoute } from '../../utils/constants/mobileScreen'
import COLORS from '../../utils/constants/colors'
import isStatistician from '../../utils/helpers/isStatistician'
import localStorageHelper from '../../utils/helpers/localStorageHelper'
import localStorageIds from '../../utils/constants/localStorageIds'

const USER_ORG_DATA_IDS = [
  localStorageIds.USER_ORG_ROLES,
  localStorageIds.ADDONS,
  localStorageIds.SELECTED_ORG,
]

const useUserOrgDataPending = () => {
  const [, setStorageTick] = useState(0)

  useEffect(() => {
    const onStorage = () => setStorageTick((tick) => tick + 1)
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  const hasSession = !!localStorage.getItem(localStorageIds.TOKEN)
  const hasUserOrgData = USER_ORG_DATA_IDS.every((id) => !!localStorageHelper(id).localStorageValue)

  return hasSession && !hasUserOrgData
}

const MobileNotificationModal = () => {
  const isMobileScreen = useIsMobileScreen()
  const translate = useTranslate()
  const userOrgDataPending = useUserOrgDataPending()
  const { redirect, pathname } = useHistoryPush()
  const { team } = useQueryParams()

  // Roles, addons and the selected org land in localStorage right after login; stay
  // hidden during that window so statisticians never get a flash of the modal. Without
  // a token (expired session, logout) there is nothing to wait for, so show as before.
  // The calendar and the profile work on a phone, so they never get it.
  const open =
    isMobileScreen && !isMobileRoute(pathname) && !userOrgDataPending && !isStatistician()

  // The org/team query params are kept, so the calendar opens on the org the user was in.
  const goTo = (path) => redirect(path, [], ['breadcrumb', 'eventType', 'profileOption'])

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <DialogWithCloseIcon open={open} dialogWidth='330px' hideCloseIcon>
        <ContainerPadding paddingValue='5%'>
          <Typography>
            {translate('ra.text.notMobileOptimised')}
            <br /> {translate('ra.text.tryDesktop')}
          </Typography>
          <Typography style={{ marginTop: 12 }}>{translate('ra.text.mobileAvailablePages')}</Typography>
          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <Button
              variant='contained'
              disableElevation
              style={{ backgroundColor: COLORS.orange, color: '#FFFFFF' }}
              onClick={() => goTo(team ? '/teamCalendar' : '/calendar')}
            >
              {translate('ra.buttons.goToCalendar')}
            </Button>
            <Button
              variant='outlined'
              style={{ borderColor: COLORS.orange, color: COLORS.orange }}
              onClick={() => goTo('/profile')}
            >
              {translate('ra.buttons.goToProfile')}
            </Button>
          </div>
        </ContainerPadding>
      </DialogWithCloseIcon>
    </div>
  )
}

export default MobileNotificationModal
